// extracted by mini-css-extract-plugin
export default {"rating":"Zz-z","numberOfStars":"_z-z","count":"aA-z","barGraphSpacing":"bA-z","barGraph":"cA-z"};